import request from '../utils/request';
//展商新闻

//保存新闻新增
export function addnews(data) {
    return request({
        url: '/frontExhibitor/zsNews/saveOrEdit',
        method: 'post',
        data: data,
    });
};
//提交新闻新增 新增界面
export function submitnews(data) {
    return request({
        url: '/frontExhibitor/zsNews/submit',
        method: 'post',
        data: data,
    });
};

//展商新闻列表
export function getnewsList(data) {
    return request({
        url: '/frontExhibitor/zsNews/list',
        method: 'get',
        params: data,
    });
}

//展商新闻审核状态统计
export function getStatus() {
    return request({
        url: '/frontExhibitor/zsNews/countAudit',
        method: 'get'
    });
}

// 根据id获取一条数据编辑
export function getOneInfo(data){
    return request({
        url: '/frontExhibitor/zsNews/view',
        method:'get',
        params: data,
    })
}

// 排序
export function order(data){
    return request({
        url: '/frontExhibitor/zsNews/editSort',
        method:'get',
        params: data,
    })
}
//列表页的提交
export function LlistSave(data){
    return request({
        url: '/frontExhibitor/zsNews/updateStatus',
        method:'get',
        params: data,
    })

}
// 删除
export function delet(data){
    return request({
        url: '/frontExhibitor/zsNews/delete',
        method:'get',
        params: data,
    })
}